






























































































































































































































































































































































































































import Cookies from 'js-cookie';
import {
  Component, Vue, Watch, mixins, mapState,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import { _isEmpty } from '@samclick-lodash';
import {
  MyaaffiliateStore, Payload, AuthorizationStore, CommonsStore, ReferralStore,
} from '@samclick-store-factory';
import { parseJWT, AUTH_TOKEN } from '@/utils/localstorage-util';
import TermsAndCondition from '@/views/Login/TermsAndCondition.vue';
import {
  emailRegex, getLanguageLookup, isBoa, getPreferredLanguages,
} from '@/utils/common-utils';
import * as appStorageUtil from '@/utils/localstorage-util';


class FormData {
  loading: boolean = false

  mailAddress: string = ''

  username: string = ''

  password: string = ''

  confirmPassword: string =''

  lastName:string = ''

  firstName: string =''

  address: string =''

  promotion: number = 1

  others: string =''

  termsOfService: boolean = false

  activeSteps: number = 1

  message : string = ''

  referrer: string = ''

  preferredLanguage: string = 'en'

  gender: string = 'M'

  address2: string = ''

  address3: string = ''

  city: string = ''

  zipCode: string = ''

  country: string = 'JP'

  skype: string = ''

  phone: string = ''

  companyName: string = ''

  selfBilling: number = 1

  taxId: string = ''

  websites: string = ''

  payment: number = 2

  // ECOPAYZ

  number: string = ''

  mail: string = ''

  lname: string = ''

  fname: string = ''

  // Bankwire

  name: string = ''

  bankName: string = ''

  branchName: string = ''

  branchCode: string = ''

  bankAddress: string = ''

  bankCompanyName: string = ''

  companyAddress: string = ''

  swiftCode: string = ''

  abaNumber: string = ''

  iban: string = ''

  additionalInfo: string = ''

  accountHolderAddress: string = ''

  intermediary: string = ''

  bankRouting: string = ''

  bankPhone: string = ''

  registeredVat: number = 0

 marketCountries: Array<number | string> = []

  vatdropdownLabel: string = 'Leave it blank if business is located in Japan, but to contact us if unsure';

  paymentMethodLabel: string = 'Bank transfer is allowed only for commissions €10,000 or above';

  duplicateError: boolean = false
}
class SignupState {
        public formData: FormData = new FormData()
}
    @Component({
      /**
         * Imported components
         * */
      components: { TermsAndCondition },
      /**
         * Stores values
         * */
      computed: {
        ...mapState({
          promotions: (state: any) => state.commons.commonsStore.promotions,
          preferredLanguages: (state: any) => state.commons.commonsStore.preferredLanguages,
          selfBilling: (state: any) => state.commons.commonsStore.selfBilling,
          yesOrNo: (state: any) => state.commons.commonsStore.yesOrNo,
          country: (state: any) => state.country.countryStore.countries,
          accountTypesCrypto: (state: any) => state.commons.commonsStore.accountTypesCrypto,
        }),
      },
      /**
         * Component properties
         * */
      props: {},
    })
export default class Signup extends mixins(SamclickMixins) {
        /**
         * Local state
         * */
        state = new SignupState();

        /**
         * Watchers
         * */
        @Watch('state.formData.registeredVat')
        promotionWatcher(newVal: number, oldVal: number) {
          if (newVal === 0) {
            this.state.formData.taxId = '';
          }
        }

        @Watch('state.formData.duplicateError')
        onDuplicateUsernameErrorChanged(newVal: boolean) {
            if (newVal) {
                this.$nextTick(() => {
                    this.scrollToError();
                });
            }
        }

        @Watch('state.formData.promotion')
        promotionWatcher1(newVal: number, oldVal: number) {
          if (newVal !== 5) {
            this.state.formData.others = '';
          }
        }

        @Watch('state.formData.payment')
        paymentWatcher(newVal: number, oldVal: number) {
          if (oldVal === 5) {
            this.state.formData.number = '';
            this.state.formData.name = '';
            this.state.formData.bankName = '';
            this.state.formData.branchName = '';
            this.state.formData.branchCode = '';
            this.state.formData.bankAddress = '';
            this.state.formData.bankCompanyName = '';
            this.state.formData.companyAddress = '';
            this.state.formData.swiftCode = '';
            this.state.formData.abaNumber = '';
            this.state.formData.iban = '';
            this.state.formData.additionalInfo = '';
            this.state.formData.accountHolderAddress = '';
            this.state.formData.intermediary = '';
            this.state.formData.bankRouting = '';
            this.state.formData.bankPhone = '';
          } else if (oldVal === 2) {
            this.state.formData.number = '';
            this.state.formData.mail = '';
            this.state.formData.lname = '';
            this.state.formData.fname = '';
          }
          else if (oldVal === 10) {
              this.state.formData.number = '';
              this.state.formData.name = '';
          }
        }

      signingIn = false;

      rules = {};

      languageLookup = '';

      isBoa = false;

      /**
         * Methods
         * */
      signup() {
        // this.showAlert(this.$data.SamclickAlert.SAVING_PROMPT, this.$data.SamclickAlert.WARNING, true).then(() => {
        this.state.formData.loading = true;
        this.signingIn = true;
        MyaaffiliateStore.signUp(new Payload({
          user: this.state.formData.mailAddress,
          pwd: this.state.formData.password,
          fname: this.state.formData.firstName,
          lname: this.state.formData.lastName,
          address1: this.state.formData.address,
          system_tag: 'MYA',
          promotion_strategy: this.state.formData.promotion,
          promotion_other_strategy: this.state.formData.others,
          referrer: this.state.formData.referrer,
          username: this.state.formData.username,
          address2: this.state.formData.address2,
          address3: this.state.formData.address3,
          city: this.state.formData.city,
          tel: this.state.formData.phone,
          skype_id: this.state.formData.skype,
          tax_id: this.state.formData.taxId,
          preferred_language: this.state.formData.preferredLanguage,
          company_name: this.state.formData.companyName,
          self_billing: this.state.formData.selfBilling,
          website: this.state.formData.websites,
          gender: this.state.formData.gender,
          zip_code: this.state.formData.zipCode,
          country: this.state.formData.country,
          market_countries: this.state.formData.marketCountries,
          account: {
            id: -1,
            affiliate_id: -1,
            type_id: this.state.formData.payment,
            number: this.state.formData.number,
            fname: this.state.formData.fname,
            lname: this.state.formData.lname,
            mail: this.state.formData.mail,
            name: this.state.formData.name,
            bank_name: this.state.formData.bankName,
            bank_address: this.state.formData.bankAddress,
            branch_name: this.state.formData.branchName,
            branch_code: this.state.formData.branchCode,
            company_name: this.state.formData.bankCompanyName,
            company_address: this.state.formData.companyAddress,
            swift_code: this.state.formData.swiftCode,
            aba_number: this.state.formData.abaNumber,
            iban: this.state.formData.iban,
            additional_info: this.state.formData.additionalInfo,
            account_holder_address: this.state.formData.accountHolderAddress,
            bank_intermediary: this.state.formData.intermediary,
            bank_routing: this.state.formData.bankRouting,
            bank_phone: this.state.formData.bankPhone,
          },
        })).then((response) => {
          this.state.formData.activeSteps = 2;
        }, (error) => {
          if (error.status === 400 && error.data && error.data.detail) {
            this.showAlert(
              this.$t(error.data.detail).toString(),
              this.$data.SamclickAlert.ERROR,
            );
            this.state.formData.duplicateError = true;
            this.state.formData.loading = false;
          }
        });
        this.state.formData.duplicateError = false;
        // }).catch(() => {});
      }

        scrollToError() {
            var element = this.$refs.usernameInput;
            if (element && element.$el) {
                element = element.$el;
            }
            if (element && element.scrollIntoView) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }

      changeLang(command) {
        let defaultLang = 'jp';
        if (isBoa()) {
          defaultLang = 'br';
        }
        window.localStorage.setItem(
          appStorageUtil.CURRENT_USER_LANG,
          command || defaultLang,
        );
        this.$i18n.i18next.changeLanguage(command);
        this.languageLookup = getLanguageLookup();
      }

      defaultCountry() {
        if (isBoa()) {
          this.state.formData.country = 'BR';
        }
      }

      backToTop() {
        this.state.formData.activeSteps = 1;
        this.state = new SignupState();
        this.$router.push({ name: 'login' });
      }

      redirectToDashboard() {
        // @ts-ignore
        this.$router.push({ name: 'dashboard' });
      }

      confirmPass(rule: any, value: any, callback: any) {
        if (!value) {
          return callback(new Error(this.$t('signup.err_confirm_password')));
        }
        if (this.state.formData.password && this.state.formData.confirmPassword && this.state.formData.password.toLowerCase() !== this.state.formData.confirmPassword.toLowerCase()) {
          return callback(new Error(this.$t('signup.err_confirm_password_no_match')));
        }
        return callback();
      }

      resendVerifyEmail() {
        MyaaffiliateStore.resendVerification(new Payload({ mail: this.state.formData.mailAddress }, false)).then((response) => {
          this.showAlert(`${this.$t('signup.msg_resend_success')} ${this.state.formData.mailAddress}`, this.$data.SamclickAlert.SUCCESS);
        });
      }

      openTerms() {
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            this.$refs.terms.toggleDialog(true);
          }
        });
      }

      getPreferredLanguages() {
        const { preferredLanguages } = this;
        return getPreferredLanguages(preferredLanguages);
      }

        get countriesForFilter() {
            const countries = CommonsStore.activeMarketCountries || [];
            return countries.filter(country => country.is_active === true);
        }

      /**
         * Computed
         * */
      // get computedVal() {
      //   return this.state.mailAddress;
      // }
      /**
         * Lifecycle hooks
         * */

      beforeMount() {
        if (!_isEmpty(this.$route.query) && this.$route.query.referrer) {
          this.state.formData.referrer = this.$route.query.referrer || '';
        }
        this.languageLookup = getLanguageLookup();
        this.isBoa = isBoa();
        this.defaultCountry();
        CommonsStore.fetchAllMarketCountriesPreLogin();
      }

      enterKey(e: object) {
        if (this.isAllowedElement(e.target.tagName, e.key)) {
          this.openTerms();
        }
      }

      mounted() {
        if (!_isEmpty(this.$route.query) && this.$route.query.token) {
          const affToken = `Bearer ${this.$route.query.token}`;
          this.state.formData.activeSteps = 3;
          Cookies.set(AUTH_TOKEN, affToken);
          AuthorizationStore.getMyInfo(new Payload({ token: affToken })).then((response) => {
            const affInfo = response.data;
            if (affInfo.status === 1) {
              affInfo.status = 5;
              AuthorizationStore.updateMyInfo(new Payload(affInfo)).then(() => {
                MyaaffiliateStore.sendVerificationEmail(new Payload({ mail: affInfo.mail }, false)).then((response) => {
                });
                Cookies.remove(AUTH_TOKEN);
              });
            }
          });
        }
      }

      beforeCreate() {
        this.commonUtil = {
          emailRegex,
        };
      }
}
